<template>
  <div :class="[baseCss, playVideosOnFacebook ? `${baseCss}-play-video-on-facebook` : null]" :title="playVideosOnFacebook ? $lang.watchOnFacebook(video ? video.title : 'Video') : null" :style="playVideosOnFacebook ? videoUrlToThumb(video ? makeSingleVideoUrl(video.id) : null) : null" @click="toFacebookVideo(video ? video.id : null)">
    <iframe v-if="!playVideosOnFacebook" seamless scrolling="no" frameborder="0" allowfullscreen="true" name="facebook-embedded-player" allow="autoplay;clipboard-write;encrypted-media;picture-in-picture;web-share" :src="src || makeFacebookListPlayerUrl(video.id)" />
  </div>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'VideoWrapper',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: 'video-wrapper'
    }
  },
  props: {
    playVideosOnFacebook: {
      type: Boolean,
      default: false
    },
    video: {
      type: Object
    },
    src: {
      type: String
    }
  },
  methods: {
    videoUrlToThumb (url) {
      const staticImages = '/static/images/'
      let src = url ? `${url.replace('/videos/', staticImages)}.jpg` : `${staticImages}${this.$route.params.slug}.jpg`
      const image = new Image()
      image.src = src
      image.onerror = () => {
        src = ''
        this.$el.classList.add(`${this.baseCss}-replacement-image`)
      }
      return {
        backgroundImage: `url(${src})`
      }
    },
    toFacebookVideo (id) {
      if (this.playVideosOnFacebook) {
        window.open(id ? `https://www.facebook.com/watch/?v=${id}` : this.makePlayerUrl(this.$route.params.slug).split('ref=')[1].split('&')[0], '_blank')
      }
    }
  }
}
</script>
<style>
.video-wrapper.video-wrapper-replacement-image::after,
.video-wrapper.video-wrapper-play-video-on-facebook::before
{
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}

.video-wrapper.video-wrapper-play-video-on-facebook
{
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.video-wrapper.video-wrapper-play-video-on-facebook:hover::before
{
  background-color: transparent;
  transition: all;
  transition-duration: .3s;
}

.video-wrapper.video-wrapper-play-video-on-facebook::before
{
  z-index: 1;
  background: no-repeat center rgba(0, 0, 0, .65) url(data:image/png;base64,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);
}

.video-wrapper.video-wrapper-replacement-image::after
{
  background: no-repeat center url('/static/images/replacement-image.jpg');
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/video-wrapper.vue